import { module } from 'angular';
import templateBuilderCommonAPI from './builder/api.html';
import templateBuilderCommonConditional from './builder/conditional.html';
import templateBuilderCommonData from './builder/data.html';
import templateBuilderCommonEvents from './builder/events.html';
import templateBuilderCommonLayout from './builder/layout.html';

export default module('app')
	.run(/* @ngInject */ (
		/** @type {import('angular').ITemplateCacheService} */ $templateCache,
	) => {
		$templateCache.put('kform/components/common/api.html', templateBuilderCommonAPI);
		$templateCache.put('kform/components/common/conditional.html', templateBuilderCommonConditional);
		$templateCache.put('kform/components/common/data.html', templateBuilderCommonData);
		$templateCache.put('kform/components/common/events.html', templateBuilderCommonEvents);
		$templateCache.put('kform/components/common/layout.html', templateBuilderCommonLayout);
	});
